import { useRouter } from '@tanstack/react-router';
import { useGetMyCarriersListSuspense } from '@uturn/api/v1';
import { Permission } from '@uturn/portal/abac';
import {
	Button,
	Separator,
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '@uturn/ui-kit';
import { t } from 'i18next';
import { useMemo } from 'react';
import { useAbac } from 'react-abac';
import ListItem from './list-item';

const List = () => {
	const { userHasPermissions } = useAbac();
	const router = useRouter();
	const { data: carriers } = useGetMyCarriersListSuspense({
		query: {
			select: (data) => data.data,
		},
	});
	const activeCarriers = useMemo(
		() => carriers.filter((carrier) => carrier.relationStatus === 'Contracted'),
		[carriers],
	);
	const pendingCarriers = useMemo(
		() => carriers.filter((carrier) => carrier.relationStatus === 'Requested'),
		[carriers],
	);

	return (
		<div
			className="w-[400px] bg-card shadow-sm border rounded-xl p-4 sticky top-[100px] h-[80vh] overflow-y-scroll"
			data-usetiful="carriers-list"
		>
			<h2 className="font-medium mb-4">Carriers</h2>
			<Separator />
			<Tabs defaultValue="active" className="mt-2">
				<TabsList className="flex justify-around">
					<TabsTrigger value="active" className="flex-1">
						{t('carrier-list.tabs.active', 'Active ({{count}})', {
							count: activeCarriers.length,
						})}
					</TabsTrigger>
					<TabsTrigger value="pending" className="flex-1">
						{t('carrier-list.tabs.pending', 'Pending ({{count}})', {
							count: pendingCarriers.length,
						})}
					</TabsTrigger>
				</TabsList>
				<TabsContent value="active">
					{activeCarriers.length > 0 ? (
						<div className="flex flex-col gap-2 py-2 overflow-y-scroll">
							{activeCarriers.map((carrier) => (
								<ListItem
									draggable
									key={carrier.carrierPartyId}
									id={carrier.carrierPartyId?.toString() ?? ''}
									// TODO: have to fix something regarding the carrier type we're getting from the BE
									carrier={{
										id: carrier.carrierPartyId ?? 0,
										name: carrier.carrierParty ?? '',
										email: carrier.carrierEmail ?? '',
										matches: carrier.totalMatches,
									}}
								/>
							))}
						</div>
					) : (
						<div className="flex flex-col p-2 h-[600px] items-center justify-center">
							<div className="flex flex-col items-center justify-center gap-4">
								<div className="text-center">
									<h2 className="text-lg text-gray-500 font-semibold">
										{t(
											'carriers-list.empty.description',
											'You have no preferred carriers (yet)',
										)}
									</h2>
								</div>
								{userHasPermissions(Permission.INVITE_CARRIER) && (
									<Button
										onClick={() => router.navigate({ to: '/carriers/add' })}
									>
										{t('pages.carriers.actions.add', 'Add carrier')}
									</Button>
								)}
							</div>
						</div>
					)}
				</TabsContent>
				<TabsContent value="pending">
					<div className="flex flex-col gap-2 py-2 overflow-y-scroll">
						{pendingCarriers.map((carrier) => (
							<ListItem
								key={carrier.carrierPartyId}
								id={carrier.carrierPartyId?.toString() ?? ''}
								// TODO: have to fix something regarding the carrier type we're getting from the BE
								carrier={{
									id: carrier.carrierPartyId ?? 0,
									name: carrier.carrierParty ?? '',
									email: carrier.carrierEmail ?? '',
									matches: carrier.totalMatches,
								}}
							/>
						))}
					</div>
				</TabsContent>
			</Tabs>
		</div>
	);
};

export default List;
